import ModelProto from "../model-proto";

export default class ViewTemplateBaseModel extends ModelProto {

    public templateId     : ID
    public name           : string
    public viewSystemType : any
    public access         : any
    public userId         : ID
    public isDefault      : boolean
    public appSettings    : any

    constructor(data:any) {
        super(data);

        // this.id          = data['id']
        this.templateId     = data['id']
        this.name           = data['name']
        this.viewSystemType = data['viewSystemType']
        this.access         = data['access']
        this.userId         = data['userId']
        this.isDefault      = data['isDefault']
        this.appSettings    = data['appSettings']

        return this;
    }

    get id() {
        return "{0}_{1}".f(this.templateId, this.viewSystemType)
    }
}
